module.exports = {"SERVER_NAME":"https://cuantoaprendi.syscode.cloud","SERVICE_URL_CONSTANT":{"parvulo":"https://cuantoaprendi-api.syscode.cloud/api/v1/parvulo-api","adminPanel":"https://cuantoaprendi-api.syscode.cloud/api/v1/parvulo-api"},"PORT":"8000","PRODUCTION_HOST":"0.0.0.0","USER_API_URL":"https://cuantoaprendi-api.syscode.cloud","LANGUAGE_LAYER":true,"productionEnv":"server","HOMEPAGE":"/app/suite/inicio","loginType":"web","clientName":"parvulo"}


//////////////////
// WEBPACK FOOTER
// ./local.env.json
// module id = 82
// module chunks = 0